/**
 * @Author: 请在根目录下.vscode改成你的名字
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-09-30 14:49:16
 * @Version: 1.0
 * @Description: 简介
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks:
 */
// 验证数字必须大于0
const validateNumber = (rule, value, callback) => {
  if (!value || value == 'null' || value == '') {
    callback()
  } else {
    const reg = /^[+]{0,1}[1-9]{1}(\d{0,9})$|^[+]{0,1}(\d{1,10}\.\d{1,2})$/
    if (reg.test(value) === false) {
      callback(new Error('请输入正确内容(正数、包括小数), 整数位最多10位，小数位最多2位'))
    } else if (Number.parseFloat(value) <= 0) {
      callback(new Error('必须大于0'))
    } else {
      callback()
    }
  }
}
import validate, { isNormalStringValidator } from '@/utils/validate'
// const phoneRegExp = /^1[3456789]\d{9}$/
// 验证手机号
// const validatePhone = (rule, value, callback) => {
//   if (!phoneRegExp.test(value)) {
//     callback(new Error('请填入正确手机号'))
//   } else {
//     callback()
//   }
// }

export const requiredRules = {
  transportType: [{ required: true, message: '必填' }],
  goodsType: [{ required: true, message: '必填' }],
  packageType: [{ required: true, message: '必填' }],
  startPlace: [{ required: true, message: '必填' }],
  stopPlace: [{ required: true, message: '必填' }],
  weight: [{ required: true, message: '必填' },
    // { type: 'number', message: '承运能力必须为数字值' },
    { validator: validateNumber, trigger: 'blur' }
  ],
  earliestTime: [
    { required: true, message: '必填' }
  ],
  latestTime: [
    { required: true, message: '必填' }
  ],
  shipmentName: [{ required: true, message: '必填' },
    { validator: isNormalStringValidator, trigger: 'blur' },
    { max: 10, message: '长度最大 10 个字符', trigger: 'blur' }],
  shipmentTel: [{ required: true, message: '必填' },
    { validator: validate('phone'), trigger: 'blur' }],
  fileUrl: [
    // { required: true, message: '必填' }
  ],
  expectPrice: [
    { required: true, message: '必填' },
    // { type: 'number', message: '期望价格必须为数字值' },
    { validator: validateNumber, trigger: 'blur' }
  ],
  startPlaceDetail: [{ max: 100, message: '长度最大 100 个字符', trigger: 'blur' }],
  stopPlaceDetail: [{ max: 100, message: '长度最大 100 个字符', trigger: 'blur' }]
}

export const rules = {
  weight: [
    // { type: 'number', message: '承运能力必须为数字值' },
    { validator: validateNumber, trigger: 'blur' }
  ],
  expectPrice: [
    // { type: 'number', message: '期望价格必须为数字值' },
    { validator: validateNumber, trigger: 'blur' }
  ],
  shipmentTel: [
    { validator: validate('phone'), trigger: 'blur' }
  ],
  shipmentName: [
    { validator: isNormalStringValidator, trigger: 'blur' },
    { max: 10, message: '长度最大 10 个字符', trigger: 'blur' }
  ],
  startPlaceDetail: [{ max: 100, message: '长度最大 100 个字符', trigger: 'blur' }],
  stopPlaceDetail: [{ max: 100, message: '长度最大 100 个字符', trigger: 'blur' }]
}
